var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 73,
    viewBox: "0 0 84 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 18.5,
    cy: 65.5,
    r: 55,
    stroke: "url(#paint0_linear_66_1574)",
    strokeWidth: 21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_1574",
    x1: 71.5,
    y1: 125.5,
    x2: 50.5,
    y2: -12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse8);
export default __webpack_public_path__ + "static/media/Ellipse-8.993347c7b9bb0301eb696bb400f236f5.svg";
export { ForwardRef as ReactComponent };